// ##############################
// // // LoginPage view styles
// #############################

import {
  container,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";

const loginPageStyle = theme => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    },
  },
  cardTitle: {
    ...cardTitle,
    color: "#535354",
    fontWeight:"600"
  },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important",
    textTransform: "none !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "",
    background: "#fff !important",
    backgroundColor: "#fff !important",
    borderRadius : '5px'
  },
  inputAdornmentIcon: {
    color: "#fff",
    // fontSize: 40,
  },
  inputField: {
    background: "#ffffff !important",
    backgroundColor: "#ffffff !important",
    // fontSize: 40,
    borderRadius : '5px',
    padding : '10px'
  },
  btnSubmit: {
    opacity: "1.0",
    zIndex: "999",
  },
  cardContainer: {
    backgroundColor: "rgba(255,255,255,0.65)",
    transform: "translate3d(0, -60px, 0)",
    minWidth:"320px",
    width:"400px",
    zIndex: "990",
    borderRadius:"4px",
  },
  cardHeader: {
    marginBottom: "0px"
  },
  cardBody: {
    padding:"10px 30px ",
  },
  cardFooter: {
    padding:"10px 0px ",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  socialLine: {
    padding: "0.9375rem 0",
    marginTop:"-65px !important"
  },
  logoTop: {
    padding: "0.9375rem 0",
    marginTop:"-50px !important",
    marginBottom:"130px !important",
  },
  linkFooter: {
    color: "#FFFFFF rgba(255,255,255,1.0)",
    zIndex: "990",
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
  }
});

export default loginPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx